import { rem } from 'polished'
import styled from 'styled-components'

import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import getPropertyIcon from 'lib/offer/getPropertyIcon'

const GroupHeading = styled(BodyText)`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
  padding: ${rem(8)} 0;
`

const Facilities = styled.ul`
  list-style-type: none;
  margin: 0;
`

const Facility = styled.li`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
  min-width: 0;
  padding: ${rem(8)} 0;
`

interface Props {
  facilityGroup: App.StructuredFacilityGroup
  title: string
}

function PropertyStructuredFacilitiesModal({ facilityGroup, title }: Props) {
  const GroupIcon = getPropertyIcon(facilityGroup.group.iconName)

  return <Modal title={title} size="S">
    <GroupHeading variant="medium" weight="bold">
      <GroupIcon size="M" />
      {facilityGroup.group.name}
    </GroupHeading>
    <Facilities>
      {facilityGroup.facilities.map(facility => <Facility key={facility.code}>
        <LineCheckIcon size="S" />
        <BodyText variant="small">{facility.name}</BodyText>
      </Facility>)}
    </Facilities>
  </Modal>
}

export default PropertyStructuredFacilitiesModal
